import { UpdateFinalFICMeetingRequest, AddFinalFICMeetingRequest, FinalFICAPI, FinalFICMeetingResponse, SaveFinalFICMeetingResponse, SimpleMessageResponse } from "../../../../api/finalFIC";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchFinalFICMeetingThunk = createAsyncThunk<
  FinalFICMeetingResponse,
  { case_id: string },
  { rejectValue: string }
>(
  "finalFIC/fetchFinalFICMeeting",
  async ({ case_id }, { rejectWithValue }) => {
    try {
      return await FinalFICAPI.getFinalFIC(case_id);
    } catch (error: any) {
      return rejectWithValue(
        error.message || "Failed to fetch Final FIC meeting"
      );
    }
  }
);

export const createFinalFICMeetingThunk = createAsyncThunk<
  SaveFinalFICMeetingResponse,
  { case_id: string; request: AddFinalFICMeetingRequest },
  { rejectValue: string }
>(
  "finalFIC/createFinalFICMeeting",
  async ({ case_id, request }, { rejectWithValue }) => {
    try {
      return await FinalFICAPI.createFinalFIC(case_id, request);
    } catch (error: any) {
      return rejectWithValue(
        error.message || "Failed to create Final FIC meeting"
      );
    }
  }
);

export const updateFinalFICMeetingThunk = createAsyncThunk<
  SimpleMessageResponse,
  { case_id: string; request: UpdateFinalFICMeetingRequest },
  { rejectValue: string }
>(
  "finalFIC/updateFinalFICMeeting",
  async ({ case_id, request }, { rejectWithValue }) => {
    try {
      return await FinalFICAPI.updateFinalFIC(case_id, request);
    } catch (error: any) {
      return rejectWithValue(
        error.message || "Failed to update Final FIC meeting"
      );
    }
  }
);